import React, { useState, forwardRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './date.module.scss';
import { ReactComponent as CalendarIcon } from '@assets/images/Fireboard/CalendarIcon.svg';
import cn from "classnames";

const DateTimePicker = ({ value, onChange, label }) => {
    const [startDate, setStartDate] = useState(null);
    const [tempDate, setTempDate] = useState(null);
    const [open, setOpen] = useState(false);

    const handleDone = () => {
        setStartDate(tempDate);
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    useEffect(() => {
    if (value) {
        setStartDate(value);
        setTempDate(value);
    }
}, [value]);

    const CustomInput = forwardRef(({ value, onClick }, ref) => {
        return (
            <div
                className={styles.customInput}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true); 
                    onClick(e);
                }}
                ref={ref}
            >
                <span>{value || label || 'Select Date'}</span>
                <CalendarIcon />
            </div>
        );
    });
    const CustomCalendarContainer = ({ className, children }) => (
        <div className={cn(className, styles.customCalendar)}>
            <div className={styles.calendarContent}>{children}</div>
            <div className={cn('row mx-0 align-items-center justify-content-center', styles.actionButtons)}>
                <button className={cn(styles.Secondarybtn, 'col mr-1')} onClick={handleCancel}>Cancel</button>
                <button className={cn(styles.primaryBtn, 'col ml-2')} onClick={handleDone}>Done</button>
            </div>
        </div>
    );

    const isSameDay = (date1, date2) =>
        date1?.getDate() === date2?.getDate() &&
        date1?.getMonth() === date2?.getMonth() &&
        date1?.getFullYear() === date2?.getFullYear();

    const filterPassedTime = (time) => {
        const now = new Date();
        if (isSameDay(tempDate, now)) {
            return time.getTime() > now.getTime();
        }
        return true;
    };

    return (
        <div className={cn('w-100', styles.wrapper)}>
            <DatePicker
                selected={tempDate}
                onChange={(date) => {
                    setTempDate(date);
                    onChange(date);
                }}
                onCalendarClose={() => setOpen(false)}
                onCalendarOpen={() => {
                    setTempDate(startDate);
                    setOpen(true);
                }}
                open={open}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, HH:mm"
                minDate={new Date()}
                filterTime={filterPassedTime}
                calendarContainer={CustomCalendarContainer}
                customInput={<CustomInput setOpen={setOpen} />}
                popperPlacement="bottom-start"
                wrapperClassName={styles.wrapper}
                label={label}
            />
        </div>
    );
};

export default DateTimePicker;
